module.exports = __webpack_public_path__ + "static/media/twitter-square-brands.c882244b.svg";